import Spinner from "./ui/Spinner.jsx";
import styled from "styled-components";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useUser} from "./hooks/useUser.js";


const FullPage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
`;

function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  
  // Load the authenticated user
  const { isLoading, isAuthenticated } = useUser();
  
  // If there is no user, redirect to the login page
  useEffect(function () {
    if (!isAuthenticated && !isLoading) {
      navigate("/login");
    }
  }, [isAuthenticated, isLoading, navigate]);
  
  // While loading, show a loading spinner
  if(isLoading) {
    return(
        <FullPage>
          <Spinner />
        </FullPage>);
  }

  // If there is a user, render the children
  if (isAuthenticated) {
    return children;
  }
  
  return null;
}

export default ProtectedRoute;